<p-dialog
  [(visible)]="isVisible"
  [style]="{ width: '80vw' }"
  [maximizable]="true"
  [header]="'case.assign-vehicle.popup-header' | translate"
  (onHide)="closeMap()"
>
  <div class="row-container">
    <div class="vehicle-list" [class.hidden]="isFullscreen">
      <div class="search-section d-flex-between">
        <div class="search-bar">
          <input
            type="text"
            class="search-input"
            [placeholder]="'case.assign-vehicle.popup-header' | translate"
            [(ngModel)]="searchTerm"
            (ngModelChange)="filterArray()"
          />
        </div>
        <div class="filter-section">
          <label class="available-checkbox">
            <input type="checkbox" (change)="filterArray()" [(ngModel)]="showOnlyAvailable"/>
            <span>{{
                "case.assign-vehicle.available-vehicles" | translate
              }}</span>
          </label>
        </div>
      </div>

      <p-table
        [value]="filteredVehicles"
        class="custom-table"
        [paginator]="false"
        selectionMode="single"
        [(selection)]="selectedVehicle"
        dataKey="id"
        [scrollable]="true"
        scrollHeight="50vh"
        responsiveLayout="stack"
        (onRowSelect)="zoomToVehicle($event)"
        (onRowUnselect)="zoomToCase($event,false)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th scope="col" style="width: 25%;">{{ "case.assign-vehicle.vehicle" | translate }}</th>
            <th scope="col" style="width: 25%;">{{ "case.assign-vehicle.status" | translate }}</th>
            <th scope="col" style="width: 25%;">{{ "case.assign-vehicle.point" | translate }}</th>
            <th scope="col" style="width: 25%;">
              {{ "case.assign-vehicle.distance" | translate }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vehicle>
          <tr [pSelectableRow]="vehicle">
            <td>
              <div>
                <div>{{ vehicle?.vehicleNo ?? "-" }}</div>
                <div style="color: #666; font-size: 14px">
                  {{ vehicle?.licensePlate ?? "-" }}
                </div>
              </div>
            </td>
            <td>
              <span
                class="status"
                [style]="{
                  'background-color':
                    vehicle?.mobileStatusVehicle?.vehicleStatus?.color,
                  color: textColorPicker(
                    vehicle?.mobileStatusVehicle?.vehicleStatus?.color
                  )
                }"
              >{{
                  vehicle?.mobileStatusVehicle?.vehicleStatus?.name ?? "-"
                }}</span
              >
            </td>

            <td>
              <div>{{ vehicle?.mobileStatusVehicle?.dot?.dotName ?? "-" }}</div>
            </td>
            <td>
              <div>{{ vehicle?.vehicleTracking?.distance ?? "-" }}</div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center">
              {{ "common.noData" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div
      class="map-container"
      *ngIf="isVisible"
      [class.fullscreen]="isFullscreen"
    >

      <div id="map"></div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-danger" (click)="closeDialog()">
      {{ "common.cancel" | translate }}
    </button>

    <button
      [disabled]="!chosenVehicle"
      type="button"
      class="btn btn-success"
      (click)="assignVehicle()"
    >
      {{ "case.assign-vehicle.popup-header" | translate | translate }}
    </button>
  </ng-template>
</p-dialog>

<app-loading [fullScreen]="true" [loading]="loading"></app-loading>
